import { useCallback } from 'react';
import { useApplicationContext } from '../../../../../../../../context/ApplicationContext/ApplicationContext';
import { useChatContext } from '../../../../../../../contexts/chat/chat.context';
import { Message } from '../../../../../../../contexts/chatSocket/reducer/chatSocketReducer.types';
import { useChatMessagesContext } from '../../../../../contexts/chatMessages.context';
import { HandleClickRetryParams } from './useChatMessagesContent.types';

const useChatMessagesContent = () => {
  const { team } = useApplicationContext();

  const chat = useChatContext();
  const chatMessages = useChatMessagesContext();

  const handleClickRetry = useCallback(
    ({ body, type, data, messageTemporaryId }: HandleClickRetryParams) => {
      chatMessages.onClickRemove(messageTemporaryId);
      chat.onSubmitMessage({
        data,
        type,
        text: body,
      });
    },
    [chat, chatMessages],
  );

  const chatMessageFormIsDisabled = chat.hasErrorInConnectionToWs || !!chat.activeChat?.wasRemoved;

  const getMessageIndex = (currentMessage: Message) => {
    return chatMessages.messages.findIndex((message) =>
      currentMessage.id
        ? message.id === currentMessage.id
        : message.tempId === currentMessage.tempId,
    );
  };

  const shouldShowUserAvatar = (currentMessage: Message) => {
    const isMine = currentMessage?.user.id === team?.userId;
    if (isMine) {
      return false;
    }

    const messageIndex = getMessageIndex(currentMessage);

    const nextMessage = chatMessages.messages[messageIndex + 1];
    const nextMessageIsFromOtherUser = nextMessage?.user.id !== currentMessage?.user?.id;
    return nextMessageIsFromOtherUser;
  };

  const isMessageFromCurrentUser = (currentMessage: Message) => {
    return currentMessage.user.id === team?.userId;
  };

  const shouldShowMessageInfo = (currentMessage: Message) => {
    const messageIndex = getMessageIndex(currentMessage);
    const lastMessage = chatMessages.messages[messageIndex - 1];

    if (!lastMessage || !currentMessage) {
      return true;
    }

    return lastMessage.user.id !== currentMessage.user.id;
  };

  return {
    handleClickRetry,
    shouldShowUserAvatar,
    shouldShowMessageInfo,
    isMessageFromCurrentUser,
    chatMessageFormIsDisabled,
  };
};

export default useChatMessagesContent;
